import { render, staticRenderFns } from "./LayersNew.vue?vue&type=template&id=33d0f9e2&scoped=true&"
import script from "./LayersNew.vue?vue&type=script&lang=js&"
export * from "./LayersNew.vue?vue&type=script&lang=js&"
import style0 from "./LayersNew.vue?vue&type=style&index=0&id=33d0f9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0f9e2",
  null
  
)

export default component.exports